module.exports = __webpack_public_path__ + "static/text@2x-cda1ea2456018956fe1be048fb958fd9.png";